import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/hooks/use-auth";
import { LocalRoutes } from "@/LocalRoutes";

const goToLogin = () => window.location.replace(LocalRoutes.LOGIN);

const Unauthorized: FC = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { isLoggedIn, isLoading, logoutMutation } = useAuth();
    const logoutMutate = logoutMutation.mutate;

    useEffect(() => {
        if (isLoading || isLoggedIn) return;
        queryClient.clear();
        logoutMutate(undefined, { onSettled: goToLogin });
    }, [isLoggedIn, isLoading, queryClient, logoutMutate]);

    return (
        <div className="flex flex-col items-center justify-center h-full w-full gap-4 p-4">
            <p className="text-4xl font-bold text-center select-none">
                {t("pages.unauthorized.title")}
            </p>
        </div>
    );
};

export default Unauthorized;
